// extracted by mini-css-extract-plugin
export default {"deviderContainer":"HrIcon_deviderContainer__0hY2Y","devider":"HrIcon_devider__MKJYA"};